import { render, staticRenderFns } from "./TopicCountChart.vue?vue&type=template&id=af797142&scoped=true&"
import script from "./TopicCountChart.vue?vue&type=script&lang=js&"
export * from "./TopicCountChart.vue?vue&type=script&lang=js&"
import style0 from "./TopicCountChart.vue?vue&type=style&index=0&id=af797142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af797142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
